import React, { useState, useContext, useEffect } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import SuiSelect from "components/SuiSelect";
import Pagination from "@mui/material/Pagination";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import RssFeedIcon from "@mui/icons-material/RssFeed";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";

import Avatar from "@mui/material/Avatar";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";

import qs from "query-string";
import toast from "react-hot-toast";

import ReadMore from "components/UpStyled/ReadMore";

import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";
import SortableList, { SortableItem } from "react-easy-sort";
import PostCard from "pages/de/posts/components/PostCard";
import BlogCard from "pages/de/posts/components/BlogCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { filterParser, sortParser } from "utils/helper";
import Tooltip from "@mui/material/Tooltip";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { useForm, Controller } from "react-hook-form";
import PostDetailModal from "pages/de/posts/detail";
import { Empty } from "antd";
import { postSortOptions } from "utils/data";
import BookIcon from "@mui/icons-material/Book";
import AddIcon from "@mui/icons-material/Add";

const PostListPage = ({ tabValue = "explore" }) => {
  //const [workTab, setWorkTab] = useState("explore");
  const [postList, setPostList] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });
  const [blogList, setBlogList] = useState([]);
  const [filteredBlogList, setFilteredBlogList] = useState([]);
  const [followingList, setFollowingList] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [searchStr, setSearchStr] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [sortObj, setSortObj] = useState(postSortOptions[0]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [selectedPost, setSelectedPost] = useState();

  const navigate = useNavigate();
  const account = useContext(AccountContext);

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm({ sort_by: postSortOptions[0] });

  useEffect(() => {
    if (account.id) {
      retrieveFollowingList("following");
      //retrieveBlogs();
    }
  }, [account]);

  useEffect(() => {
    if (account.id) {
      if (tabValue != "blog") {
        const offset = pageSize * (page - 1);
        const limit = pageSize;
        if (tabValue == "following") {
          const followingIds = followingList.map((x) => x.id);
          if (followingIds.length == 0) {
            setPostList({ hits: [], nbHits: 0, estimatedTotalHits: 0 });
          } else {
            const filter = {
              owner_id: followingIds,
            };

            retrievePosts(offset, limit, searchStr, filter);
          }
        } else {
          retrievePosts(offset, limit, searchStr);
        }
      }
    }
  }, [tabValue, followingList, sortObj?.value, account]);

  const retrieveFollowingList = async (type) => {
    try {
      const userList = await api.social.followlist(type);
      setFollowingList(userList?.data.list || []);
    } catch (err) {
      console.log(err);
    }
  };

  const retrievePosts = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
    const payload = { offset, limit };
    if (q) {
      payload["q"] = q;
    }
    //let myFilter = { owner_id: "usr_01GGDDCBXBGJCR1AM4Q7YZXQJ1" }; //Dr. J's user id
    let myFilter = {};

    if (Object.keys(filter).length > 0) {
      myFilter = { ...myFilter, ...filter };
    }

    //get sorting options from sortObj
    let sortStr = "";

    if (sortObj && sortObj.value) {
      sortStr = sortParser(sortObj.value);
    }

    myFilter = {
      ...myFilter,
    };

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
      setFilterObj(myFilter);
    }
    if (sortStr) {
      payload["sort"] = [sortStr];
    }
    try {
      const { data } = await api.post.searchPosts(payload);
      setPostList(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleApply = (input = {}) => {
    let data = getValues();
    data = { ...data, ...input };
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    setSearchStr(data["keywords"]);
    let myFilter = {};
    console.log(data);

    if (tabValue != "blog") {
      retrievePosts(offset, limit, data["keywords"], myFilter);
    } else {
      const filteredList = blogList.slice(offset, limit);
      setFilteredBlogList(filteredList);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;
    if (tabValue != "blog") {
      retrievePosts(offset, limit, searchStr);
    } else {
      const filteredList = blogList.slice(offset, limit);
      setFilteredBlogList(filteredList);
    }
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    if (tabValue != "blog") {
      retrievePosts(offset, limit, searchStr);
    } else {
      const filteredList = blogList.slice(offset, limit);
      setFilteredBlogList(filteredList);
    }
  };

  const pageCount = parseInt(Math.ceil(postList.estimatedTotalHits / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }

  const entriesStart = pageSize * (page - 1) + 1;
  let entriesEnd =
    pageSize * page > postList.estimatedTotalHits ? postList.estimatedTotalHits : pageSize * page;
  if (tabValue == "blog") {
    entriesEnd = pageSize * page > blogList.length ? blogList.length : pageSize * page;
  }

  const handleSwitchTabs = (tab) => {
    //setWorkTab(tab);
    setPage(1);
  };

  return (
    <SuiBox>
      <SuiBox display="flex">
        <SuiBox flexGrow={1}>
          {/* <SuiBox display="flex" justifyContent="space-between" alignItems="center" gap={1}>
            <SuiBox display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
              <SuiButton
                sx={{ textTransform: "capitalize", p: "4px 12px", mx: 1, minHeight: 24 }}
                color="dark"
                variant={tabValue == "explore" ? "contained" : "text"}
                fontWeight="bold"
                onClick={() => handleSwitchTabs("explore")}
              >
                <LanguageOutlinedIcon sx={{ mr: 0.5 }} />
                Explore
              </SuiButton>
              |
              <SuiButton
                sx={{ textTransform: "capitalize", p: "0px 8px", mx: 1, minHeight: 24 }}
                color="dark"
                variant={tabValue == "foryou" ? "contained" : "text"}
                fontWeight="bold"
                onClick={() => handleSwitchTabs("foryou")}
              >
                <FavoriteIcon sx={{ mr: 0.5 }} />
                For You
              </SuiButton>
              |
              <SuiButton
                sx={{ textTransform: "capitalize", p: "0px 8px", mx: 1, minHeight: 24 }}
                color="dark"
                variant={tabValue == "following" ? "contained" : "text"}
                fontWeight="bold"
                onClick={() => handleSwitchTabs("following")}
              >
                <PeopleAltOutlinedIcon sx={{ mr: 0.5 }} />
                Following
              </SuiButton>
            </SuiBox>
          </SuiBox> */}
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" gap={1} my={1}>
            <SuiBox px={1}>
              <SuiBox display="flex" alignItems="center" gap={2}>
                <SuiButton variant="gradient" color="dark" onClick={() => navigate("/post/create")}>
                  <AddIcon />
                  New Post
                </SuiButton>
              </SuiBox>
            </SuiBox>
            {tabValue != "blog" ? (
              <SuiBox
                component="form"
                onSubmit={handleSubmit(handleApply)}
                sx={{ flexGrow: 1, px: 1 }}
              >
                <SuiBox
                  display="flex"
                  alignItems="center"
                  sx={{ gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}
                >
                  <div style={{ width: 160, backgroundColor: "white" }}>
                    <SuiSelect
                      options={postSortOptions}
                      onChange={(opt) => {
                        setSortObj(opt);
                      }}
                      defaultValue={sortObj}
                    />
                  </div>
                  <div style={{ maxWidth: 300, flex: "1 1 auto" }}>
                    <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
                  </div>
                  <div>
                    <SuiButton variant="gradient" color="dark" type="submit">
                      Search
                    </SuiButton>
                  </div>
                </SuiBox>
              </SuiBox>
            ) : null}
          </SuiBox>
          <SuiBox sx={{ width: "100%", minHeight: "70vh" }}>
            {(postList.hits.length == 0 && tabValue != "blog") ||
            (filteredBlogList.length == 0 && tabValue == "blog") ? (
              <SuiBox my={4}>
                <Empty />
              </SuiBox>
            ) : (
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 200: 1, 400: 2, 700: 3, 1000: 4, 1200: 5, 1400: 5 }}
              >
                <Masonry gutter="20px">
                  {tabValue != "blog"
                    ? postList.hits.map((p, index) => (
                        <SuiBox>
                          <PostCard
                            index={index}
                            post={p}
                            sx={{ height: "auto", width: "100%" }}
                            handleClick={() => {
                              setDetailVisible(true);
                              setSelectedPost(p);
                            }}
                          />
                        </SuiBox>
                      ))
                    : filteredBlogList.map((blog) => (
                        <div
                          className="mx-2 my-2"
                          style={{
                            overflow: "hidden",
                          }}
                        >
                          <BlogCard
                            blog={blog}
                            onClick={() =>
                              blog?.id ? navigate(`/social/blog?viewblogid=${blog.id}`) : null
                            }
                          />
                        </div>
                      ))}
                </Masonry>
              </ResponsiveMasonry>
            )}
          </SuiBox>
        </SuiBox>
      </SuiBox>
      <SuiBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={3}
      >
        <div className="flex items-center">
          {tabValue != "blog" ? (
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {postList.estimatedTotalHits} entries
              </SuiTypography>
            </SuiBox>
          ) : (
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {blogList.length} entries
              </SuiTypography>
            </SuiBox>
          )}

          <SuiBox display="flex" alignItems="center" gap={1}>
            <SuiSelect
              defaultValue={{ value: pageSize, label: pageSize }}
              options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
              onChange={handleChangeRowsPerPage}
              size="small"
            />
            <SuiTypography variant="caption" color="secondary">
              entries per page
            </SuiTypography>
          </SuiBox>
        </div>
        <Pagination
          variant={"outlined"}
          color={"info"}
          count={pageOptions.length}
          defaultPage={page}
          onChange={handleChangePage}
        />
      </SuiBox>

      {detailVisible && selectedPost ? (
        <PostDetailModal
          handleClose={(postDetail) => {
            const newPostList = { ...postList };
            for (let i = 0; i < newPostList.hits.length; i++) {
              if (newPostList.hits[i].id == postDetail.id) {
                newPostList.hits[i] = postDetail;
              }
            }
            setPostList(newPostList);
            setDetailVisible(false);
          }}
          visible={detailVisible}
          post={selectedPost}
          allPosts={postList?.hits || []}
        />
      ) : null}
    </SuiBox>
  );
};

export default PostListPage;
